<template>
  <v-layout row wrap>
    <v-flex xs12 md4 pr-4>
      <v-text-field v-model="apprenticeship.ApprenticeshipSiteType" label="Site Type" readonly></v-text-field>
    </v-flex>
    <v-flex xs12 md8>
      <v-text-field
        required
        v-model="apprenticeship.ApprenticeshipSiteName"
        label="Site Name:"
        :readonly="disableFields"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md3 pr-4>
      <date-picker
        label="Start Date"
        v-model="apprenticeship.DateFrom"
        :rules="[rules.EduDateCheck(apprenticeship.DateFrom, apprenticeship.DateTo)]"
        :disabled="disableFields"
      ></date-picker>
    </v-flex>
    <v-flex xs12 md3 pr-4>
      <date-picker
        label="End Date"
        v-model="apprenticeship.DateTo"
        :rules="[rules.EduDateCheck(apprenticeship.DateFrom, apprenticeship.DateTo)]"
        :disabled="disableFields"
      ></date-picker>
    </v-flex>
    <v-flex xs12 md3 pr-4>
      <v-text-field v-model="apprenticeship.City" label="City:" :readonly="disableFields"></v-text-field>
    </v-flex>
    <v-flex xs12 md3>
      <v-text-field v-model="apprenticeship.State" label="State:" :readonly="disableFields"></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Rules from '../../validation/rules'
import moment from 'moment'
import DatePickerVue from '../DatePicker.vue';
export default {
  props: {
    apprenticeship: Object,
    disableFields: Boolean
  },
  data() {
    return {
      menu: false,
      menu2: false,
      rules: Rules,
    }
  },
  methods: {
    
  },
  watch: {
    apprenticeship: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
  components: {
    'date-picker' : DatePickerVue
  }
}
</script>

<style>
.theme--light.v-icon.v-icon--disabled {
  color: rgba(0, 0, 0, 1) !important;
}
.theme--light.v-input--is-disabled .v-label,
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: rgba(0, 0, 0, 0.54);
}

.theme--light.v-text-field.v-input--is-disabled
  > .v-input__control
  > .v-input__slot:before {
  border-image: none;
}
</style>
